import React from "react";
import { useAppSelector } from "../../../hooks/hooks";
import {
  selectVehicleReport,
  selectVehicleReportStatus,
} from "../../../features/reports/reportsSlice";
import {
  Container,
  ContainerLineItem,
  Padding,
  Table,
  Text,
} from "@kidslivesafe/sc-react";

import { VehicleReportType } from "../../../features/reports/reportTypes";
import LoadingContainerLineItem from "../../../components/UIComponents/LoadingContainerLineItem/LoadingContainerLineItem";

const VehicleSpecs: React.FC<{
  containerId: string;
  printReady?: boolean;
  vehicleSpecsSummary: any[];
}> = ({ containerId, printReady, vehicleSpecsSummary }) => {
  let pulledReport = useAppSelector(selectVehicleReport) as VehicleReportType;
  const vehicleReportStatus = useAppSelector(selectVehicleReportStatus);

  const loading = vehicleReportStatus === "loading";

  return (
    <Padding
      space="none"
      breakpointStyles={{
        mobile: {
          left: "md",
          right: "md",
        },
      }}
    >
      <Container
        containerId={containerId}
        containerTitle={`Vehicle Specs ${
          loading
            ? ""
            : `(${
                pulledReport &&
                pulledReport.vehicleDetails &&
                vehicleSpecsSummary[0]
                  ? Object.keys(vehicleSpecsSummary[0]).length
                  : 0
              })`
        }`}
      >
        {loading ? (
          <LoadingContainerLineItem lineItemHeader children />
        ) : (
          <ContainerLineItem
            lineItemHeader="Full Vehicle Specs"
            isOpen={printReady ? true : true}
          >
            {vehicleSpecsSummary[0] ? (
              <Table tableDataObject={vehicleSpecsSummary[0]} />
            ) : null}
          </ContainerLineItem>
        )}
      </Container>
    </Padding>
  );
};

export default VehicleSpecs;
